import { useEffect, useState } from "react";
import { API } from "@/App";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

const WD_LONG = ["Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi", "Pazar"];

export const ExtraClassDialog = ({ slot, businessId, onClose }) => {
  const [sug, setSug] = useState(null);
  const [form, setForm] = useState({ trainer_id: "", room_id: "", capacity: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!slot) return;
    setSug(null);
    fetch(`${API}/businesses/${businessId}/open-classes/suggest?weekday=${slot.weekday}&start_time=${slot.start_time}`, { credentials: "include" })
      .then((r) => r.json())
      .then((d) => {
        setSug(d);
        setForm({ trainer_id: d.trainers?.[0]?.trainer_id || "", room_id: d.rooms?.[0]?.room_id || "", capacity: "" });
      });
  }, [slot, businessId]);

  const room = sug?.rooms?.find((r) => r.room_id === form.room_id);
  if (!slot) return null;
  const create = async () => {
    setBusy(true);
    try {
      const res = await fetch(`${API}/businesses/${businessId}/open-classes`, {
        method: "POST", credentials: "include", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ date: sug.date, start_time: sug.start_time, end_time: sug.end_time, trainer_id: form.trainer_id, room_id: form.room_id, branch: sug.branch, capacity: Number(form.capacity || room?.capacity || 1) }),
      });
      const d = await res.json();
      if (!res.ok) throw new Error(d.detail || "Oluşturulamadı");
      toast.success("Ek grup dersi açıldı — linkte görünüyor");
      onClose(true);
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  const sel = "w-full h-10 rounded-xl border border-input bg-white px-3 text-sm";

  return (
    <Dialog open={!!slot} onOpenChange={(o) => !o && onClose(false)}>
      <DialogContent aria-describedby={undefined} className="max-w-md" data-testid="extra-class-dialog">
        <DialogHeader><DialogTitle>Ek Grup Dersi Aç</DialogTitle></DialogHeader>
        {!sug ? <Loader2 className="w-6 h-6 animate-spin mx-auto" /> : (
          <div className="space-y-3">
            <p className="text-sm text-slate-700" data-testid="extra-class-when">{WD_LONG[slot.weekday]} {sug.date.split("-").reverse().join(".")} · {sug.start_time}–{sug.end_time}{slot.waitlist ? ` · ${slot.waitlist} kişi bekleme listesinde` : ""}</p>
            {!sug.trainers.length || !sug.rooms.length ? (
              <p className="text-sm text-red-600 bg-red-50 rounded-xl p-3" data-testid="extra-class-unavailable">
                {!sug.trainers.length ? "Bu saatte boşta olan başka antrenör yok (aynı saatin hocası hariç)." : "Bu saatte boş oda yok."}
              </p>
            ) : (
              <>
                <div><Label>Antrenör (boşta olanlar)</Label>
                  <select value={form.trainer_id} onChange={(e) => setForm({ ...form, trainer_id: e.target.value })} className={sel} data-testid="extra-class-trainer">
                    {sug.trainers.map((t) => <option key={t.trainer_id} value={t.trainer_id}>{t.name}</option>)}
                  </select></div>
                <div><Label>Oda (boş olanlar)</Label>
                  <select value={form.room_id} onChange={(e) => setForm({ ...form, room_id: e.target.value })} className={sel} data-testid="extra-class-room">
                    {sug.rooms.map((r) => <option key={r.room_id} value={r.room_id}>{r.name} ({r.capacity} kişi)</option>)}
                  </select></div>
                <div><Label>Kontenjan</Label>
                  <Input type="number" min="1" placeholder={`${room?.capacity || ""} (oda)`} value={form.capacity} onChange={(e) => setForm({ ...form, capacity: e.target.value })} className="rounded-xl" data-testid="extra-class-capacity" /></div>
                <Button onClick={create} disabled={busy} className="w-full rounded-xl bg-emerald-600 hover:bg-emerald-700" data-testid="extra-class-submit">
                  {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Ek Dersi Aç"}
                </Button>
              </>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
